<template>
  <v-dialog v-model="dialog" max-width="500" :persistent="loading">
    <v-card>
      <v-card-title>Reescrever com IA</v-card-title>
      <v-card-text>
          <v-text-field
            label="Título"
            v-model="changelog.title"
            outlined
            required
            :rules="[(v) => !!v || 'Título é obrigatório']"
            :disabled="loading"
            :loading="loading"
          ></v-text-field>
          <v-textarea
            label="Conteúdo"
            v-model="changelog.content"
            outlined
            required
            dense
            rows="6"
            :rules="[(v) => !!v || 'Conteúdo é obrigatório']"
            :disabled="loading"
            :loading="loading"
          />

          <v-select
            label="Categoria"
            v-model="changelog.category"
            :items="categories"
            outlined
            dense
            required
            :disabled="loading"
            :loading="loading"
          >
            <template v-slot:item="{ item }">
              <v-icon left small :color="item.icon">{{ item.icon }}</v-icon>
              {{ item.text }}
            </template>
          </v-select>

          <v-btn
            @click="aiRewrite"
            :loading="loading"
            :disabled="loading"
            color="primary"
            block
          >
            <v-icon left>mdi-robot</v-icon>
            Reescrever com IA
          </v-btn>

          <v-alert v-if="error" type="error" class="mt-4">
            {{ error }}
          </v-alert>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="close" :disabled="loading">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="accept"
          :loading="loading"
          :disabled="loading"
        >
          Aceitar Sugestão
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import CHANGELOG from "@/services/ultimate/changelogs.js";
export default {
  data() {
    return {
      dialog: false,
      loading: false,
      error: null,
      resolve: null,
      changelog: this.defaultChangelog(),
      categories: [
        { text: "Nova Funcionalidade", value: "NEW_FEATURE", icon: "mdi-plus" },
        { text: "Desempenho", value: "PERFORMANCE", icon: "mdi-speedometer" },
        { text: "Segurança", value: "SECURITY", icon: "mdi-shield-check" },
        { text: "Correção de Bug", value: "BUG_FIX", icon: "mdi-bug" },
        { text: "Nova API", value: "NEW_API", icon: "mdi-api" },
        { text: "Novo Relatório", value: "NEW_REPORT", icon: "mdi-chart-box" },
        { text: "Nova UI", value: "NEW_UI", icon: "mdi-palette" },
        { text: "Novo Tool", value: "NEW_TOOL", icon: "mdi-wrench" },
        { text: "Outro", value: "OTHER", icon: "mdi-information" },
      ],
    };
  },
  methods: {
    defaultChangelog() {
      return {
        title: "",
        content: "",
        category: "OTHER",
      };
    },
    open(changelog) {
      this.dialog = true;
      this.changelog = changelog || this.defaultChangelog();
      this.aiRewrite();
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    close() {
      this.dialog = false;
      this.resolve(false);
      this.resolve = null;
    },
    accept() {
      this.resolve(this.changelog);
      this.resolve = null;
      this.close();
    },
    async aiRewrite() {
      try {
        this.loading = true;
        this.error = null;
        const response = await CHANGELOG.aiRewriteChangelog({
          title: this.changelog.title,
          content: this.changelog.content,
        });
        console.log(response);
        this.changelog = response.changelog;
      } catch (error) {
        this.error = error.message || "Erro ao reescrever com IA";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
